export default {
  defense: {
    loadingTips: '加载中.....',
    clientIP: '客户端IP',
    purchase: '购买高防IP',
    off: '关闭',
    on: '开启',
    Search:'搜索',
    start:'开始时间',
    end:'结束时间',
    ipdetail: {
      selectRange: '选择范围',
      //blocking tab
      blockingtab: {
        labels: {
          domainName: '域名',
          blockTime: '被封时间 ',
          blockDuration: '封禁时长',
          type: '类型',
          reason: '原因',
          actions: '操作'
        },
        batchUnblock: '批量解封被禁IP',

        blockedClientIp: '被封客户端IP',
        blockedClientIpTips: '该被封禁IP列表是拉取选择时间内曾经被封禁IP日志记录获取的；<br />' +
          '如果客户端IP没有访问记录，若它被封禁也会没有记录。',
        seconds: '秒',
        actionTips: '注：解封操作成功，被封记录依然会存在，<br />但该客户端IP已经是解封的，请不要重复操作。',
        Unblock: '解封',
        noDomainConfiguration: '没有域名配置',
        domainNotEnabled: '域名未开启',
        sourceServerHealthCheckFailed: '源服务器健康检查失败',
        appTokenVerifyFailed: 'APP_TOKEN验证失败',
        noAppToken: '没有APP_TOKEN',
        blockedByBlacklist: '黑名单拦截',
        noAntiddosIpConfiguration: '没有高防ip配置',
        blockedForSpecialHttpRefererAttack: '特殊HTTP_REFERER攻击封禁',
        headerError: 'header错误',
        triggeredCountryInterceptionRule: '触发区域控制国家拦截规则',
        triggeredProvinceInterceptionRule: '触发区域控制省份拦截规则',
        triggeredCityInterceptionRule: '触发区域控制城市拦截规则',
        triggeredPreciseAccessRefuse: '触发精准访问拦截规则：拒绝访问',
        triggeredPreciseAccessBlockIP: '触发精准访问拦截规则：封禁IP',
        noSourcePort: '没有源端口',
        IPHasBeenBlocked: '该IP已被封禁',
        triggeredFrequencyLimit: "单个客户端访问过多：触发${seconds}秒${times}次限制",
        triggeredFrequencyQueriesLimit: '单个客户端访问过快：',
        triggeredFrequencyInterceptionRule: '触发频率控制拦截：触发${seconds}秒${times}次限制',
        triggeredFrequencyBlockURIRule: '触发频率控制封禁URI：触发${seconds}秒${times}次限制',
        triggeredFrequencyBlockIPRule: '触发频率控制封禁IP：触发${seconds}秒${times}次限制',
        captchaIsRequiredMultipleTimes: '多次要求人机验证：',



      },
      //cc attack tab
      ccatackTab: {
        labels: {
          attackTime: '攻击时间',
          antiddosIP: '高防IP',
          domainName: '域名',
        },


      },
      ddosatackTab: {
        labels: {
          attackTime: '攻击时间',
          antiddosIP: '高防IP',
          flow: 'DDOS流量',
        },


      },

      infoTab: {
        basicInfo: '基本信息',
        configInfo: '配置信息',
        labels: {
          userId: '客户信息:',
          orderNo: '订单号:',
          instance: '实例: ',
          status: '状态:',
          appToken: 'App Token:',
          creation: '创建日期:',
          expiration: '有效日期:',
          line: '线路:',
          defense: '防御值:',
          bandwidth: '带宽:',
          qps: '业务QPS:',
          domains: '防御域名数:',
          ports: '防护端口数:',
          regionalBlocking: '区域封禁:',
          staticCaching: '静态页面缓存:',
          preciseAccess: '精准访问控制:',
        },
        buttons: {
          generate: '生成APP_TOKEN',
          configuring: '配置中',
          update: '更新APP_TOKEN',
        }

      },
      monitorTab: {
        labels: {
          minute: '分钟',
          hour: '小时',
        },

      },
      trafficTab:{
        labels:{
          time_30:'30分钟',
          time_60:'1小时',
          time_1440:'1天',
          Unit:'单位',
          input_bps:"输入流量"
        }
      },
    },
    //AccelerationsRules
    acceleration: {
      customizeRules: '自定义规则',
      staticCacheList: '静态页面缓存加速列表：',

      ruleName: '规则名称',
      editRuleTitle: '编辑静态页面加速规则',
      addRuleTitle: '添加静态页面加速规则',
      deleteConfirm: '确定删除该规则?',
      deleteRule: '删除规则',
      warning: '警告',
      labels: {
        uri: 'URI',
        standard: '标准',
        enhanced: '增强',
        noCache: '不缓存',
        expiration: '过期时间',
        default: '默认系统配置',
        oneHour: '1小时',
        oneDay: '1天',
        tenDays: '10天',
        thirtyDays: '30天',
        settingTime: '设置时间',
        actions: '操作',
        mode: '模式',
      },
      buttons: {
        edit: '编辑',
        delete: '删除',
        cancel: '取消',
        addRule: '添加规则',

      }
    },
    antiddos: {
      noDataTips1: '没有数据，您可以',
      noDataTips2: '创建一个实例',
      labels: {
        all: '所有地区',
        IP: '高防IP',
        searchPlaceholder: '输入高防IP搜索',
        line: '线路: ',
        bandwidth: '带宽（Mbps）',
        defense: '防御值（Gbps）',
        domains: '防御域名数',
        ports: '防护端口数',
        qps: '业务QPS',
        validityPeriod: '有效期',
        charges: '费用',
        status: '状态',
        abnormal: '异常',
        normal: '正常',
        configChanging: '升级配置中',
        configuring: '配置中',
        paused: '暂停',
        actions: '操作',
      },
      buttons: {
        set: '设置',
        renew: '续费',
        view: '详细',
        monitoring: '监控信息',
        changeConfiguration: '升降配置',
      }

    },
    attackLog: {

      oneMinute: '1分钟',
      fiveMinutes: '5分钟',
      thirtyMinutes: '30分钟',
      oneHour: '1小时',
      oneDay: '1天',
      labels: {
        domain: '域名',
        defenseIP: '防御IP',
        proxyHash: '代理哈希值',
        hashTips: '同一浏览器使用不同IP<br />只会产生唯一的哈希值',
        ipUsingTheHash: '使用该哈希值的IP数量',
        clientIPHashTips: '使用了同一哈希值但不同客户端IP的数量,<br />表明同个浏览器使用了多少个代理IP',
        totalRequests: '请求总次数',
        attackRequests: '攻击请求次数',
        actions: '操作',


      },
      buttons: {
        viewDetails: '查看详情',
      }
    },
    domainSetView: {
      log4SHell: 'Apache Log4Shell 远程执行恶意代码漏洞',
      inBlacklist: '个黑名单',
      inWhitelist: '个白名单',
      current: '当前已设置',
      customRules: '条自定义规则',
      frequencyTips: '正常以外的模式会进行人机识别，需要开启人机识别功能',
      healthCheckTips: '关闭后，将不再对源站作健康检查，请求直接回源',
      oscpTips:"开启后,将减少访客进行SSL证书握手的步骤.提高访问访问HTTPS域名的速度.需要配置SSL证书才能使用",
      labels: {
        domain: '域名：',
        vulnerabilityInterception: '漏洞拦截功能',
        blacklistWhitelist: '黑白名单（针对域名）',
        regionalBlocking: '区域封禁（针对域名）',
        preciseAccess: '精准访问控制',
        frequency: '频率控制',
        builtinMode: '内置模式',
        normal: '正常',
        urgent: '攻击紧急',
        strict: '严格',
        superStrict: '超级严格',
        cacheMode: '缓存模式（针对域名）',
        staticCache: '静态页面缓存加速',
        mode: '模式：',
        strong: '增强',
        noCache: '不缓存',
        all: '不限后缀',
        warningNotice: '预警通知',
        humanIdentify: '人机识别',
        jsVerify: 'JS验证',
        slide: '滑块验证',
        healthCheck: '健康检查',
        appToken: 'APP Token',
        proxyAttack: '代理攻击控制',
        observationMode: '观察模式:只记录攻击信息而不采取措施,攻击记录可在全量日志中查询.',
        interceptionMode: '拦截模式:既记录攻击信息,也进行拦截',
        loose: '宽松',
        superLoose: '超级宽松',
        cacheTime: '缓存时间（秒）',
        interceptionLevel: '拦截等级',
        oscp:'OSCP 装订'

      },
      buttons: {
        setBlacklist: '设置黑白名单',
        setBlocking: '设置区域封禁',
        customizeRules: '自定义规则',
        clearAllCache: '清除缓存',
        refreshUriCache: '刷新指定URI缓存',
        save: '保存',
        setWarningNotice: '设置预警通知',
      }

    },
    layer4SetView: {

      labels: {
        set: '设置：',
        regionalBlocking: '区域封禁（针对该规则）',
        regionalBlockingTips: '请先升级本实例以开通本项服务',

      },


    },
    featuresLog: {

      labels: {
        oneMinute: '1分钟',
        fiveMinutes: '5分钟',
        thirtyMinutes: '30分钟',
        oneHour: '1小时',
        oneDay: '1天',
        domain: '域名',
        userAgent: 'User-Agent',
        totalRequests: '请求总次数',
        actions: '操作',

      },
      buttons: {
        addPreciseControl: '添加精准访问控制',
      }

    },
    frequencyRules: {
      deleteConfirm: '确定删除该规则?',
      deleteRule: '删除规则',
      warning: '警告',
      labels: {
        frequencyRules: '频率控制列表，域名:',
        ruleName: '规则名称',
        protectedURI: '防护URI',
        interval: '校验时长',
        singleIPVisits: '单一IP访问次数',
        matchingRule: '匹配规则',
        blockingType: '阻断类型',
        blockingTime: '封禁时间',
        actions: '操作',
      },
      buttons: {
        customizeRules: '自定义规则',
        addRule: '添加规则',
        edit: '编辑',
        delete: '删除',
        cancel: '取消',
      }

    },
    fullLog: {
      noIPSelected: '未选择高防IP',
      ipNotExist: '高防IP不存在',
      qps: 'QPS',
      ccQPS: 'CC攻击每秒请求次数',
      totalQPS: '总QPS',
      defenseQPS: '智能抵御攻击QPS',
      labels: {
        accessTime: '访问时间',
        domain: '域名',
        protocol: '方法',
        url: '请求url',
        clientIP: '客户端ip',
        statusCode: '状态码',
        permission: '是否放行',
        humanIdentify: '人机校验',
        crawler: '爬虫类型',
        actions: '操作',
        viewRawLog: '查看原始日志',
      },

    },
    index: {
      labels: {
        ipCategory: '高防IP',
        antiDdosIP: '实例',
        websiteProtection: '网站防护',
        nonWebProtection: '非网站防护',
        accessLog: '访问日志',
      },

    },
    indexLog: {
      labels: {
        accessLog: '访问日志',
        layerLog: '四层日志',
        fullLog: '全量日志',
        visits: '访问次数',
        requestRegion: '请求地区排行',
        requestIP: '请求IP排行'
      },

    },
    ipSetView: {
      switchTips: '可针对DDoS攻击警报等进行设置',
      labels: {
        set: '设置：',
        setProtectionLevel: '设置高防IP的防护等级',
        ipLevelAlerts: 'IP层面预警',
        levelAlertsSwitch: 'DDoS攻击预警',
      },
      buttons: {
        setAlertNotifications: '设置预警通知',
      }
    },
    ipView: {
      labels: {
        antiDdosIP: '高防IP：',
        details: '详细信息',
        monitoring: '监控信息',
        ipBlocking: 'IP封堵状态查询',
        ccAttack: 'CC攻击记录',
        traffic:'未过滤流量',
        ddosAttack: 'Ddos攻击记录',

      },
    },
    layerChart: {
      pps: 'pps(每秒包数 单位：个)',
      qps: 'qps(每秒请求数)',
      ccQPS: 'CC攻击QPS(每秒请求数)',
      conns: 'conns(当前连接数 单位：个)',
      in: '入流量',
      out: '出流量',
      average: '平均流量',
      flowPerSecond: '每秒流量 (Mbps)',
      labels: {
        oneMinute: '1分钟',
        fiveMinutes: '5分钟',
        thirtyMinutes: '30分钟',
        oneHour: '1小时',
        oneDay: '1天',
        defenseIP: '防御IP',
      },
      buttons: {
        turnOnRealTime: '开启实时',
      },
    },
    layerLog: {
      labels: {
        oneMinute: '1分钟',
        fiveMinutes: '5分钟',
        thirtyMinutes: '30分钟',
        oneHour: '1小时',
        oneDay: '1天',
        defenseIP: '防御IP',
        enterKeywordToSearch: '输入关键词搜索',
        time: '时间',
        clientIP: '客户端IP',
        clientPort: '客户端口',
        provience:"省份",
        city:"城市",
        upstreamIP: '源站IP',
        defensePort: '回源端口',
        protocol: '协议',
        connections: '连接数',
        outflow: '出流量',
        inflow: '入流量',
        requestTime: '请求时间(秒)',
      },
      new_conns:"新建连接数",
      server_conns:"总连接数"

    },
    preciseRules: {
      deleteConfirm: '确定删除该规则?',
      deleteRule: '删除规则',
      warning: '警告',
      labels: {
        customizeRules: '自定义规则',
        preciseAccessList: '精准访问控制列表：',
        ruleName: '规则名称',
        and: 'AND',
        or: 'OR',
        ruleAction: '动作',
        refusal: '拒绝',
        allow: '放行',
        challenge: '挑战',
        expiration: '规则有效期',
        settingTime: '设置时间',
        actions: '操作',
        conditionalRelation: '条件关系',
        matchingCondition: '匹配条件',
      },
      buttons: {
        addRule: '添加规则',
        edit: '编辑',
        delete: '删除',
        cancel: '取消',
      }

    },
    rankLog: {
      selectDomain: '请选择域名',
      labels: {
        oneMinute: '1分钟',
        fiveMinutes: '5分钟',
        thirtyMinutes: '30分钟',
        oneHour: '1小时',
        oneDay: '1天',
        selectIP: '请选择高防IP',
        selectDomain: '请选择域名',
        domain: '域名',
        requestIP: '请求IP地址',
        defenseIP: '防御IP',
        totalRequests: '请求总次数',
        normalRequests: '正常请求次数',
        attackRequests: '攻击请求次数',
      }

    },
    refreshCache: {
      inputTips: '请输入刷新的URL，多个URL一行一个,格式以http或https开头,仅支持GET请求,错误的格式将被自动忽略<br />\n' +
        '                刷新任务生效时间大约为5分钟。具体结果见缓存刷新记录',
      invalidURIMsg: '合法URI数量为0,请检查格式和内容并重新提交',
      labels: {
        refreshURICache: '刷新指定URI缓存:',
        url: 'URL',
          records: '缓存刷新记录',
        action: '操作内容',
        productType: '产品类型',
        time: '操作时间',
        status: '状态',
      },
      buttons: {
        submitting: '提交中',
        submit: '提交',
      }

    },
    regionLog: {
      noIPSelected: '请选择高防IP',
      ipNotExist: '高防IP不存在',
      labels: {
        oneMinute: '1分钟',
        fiveMinutes: '5分钟',
        thirtyMinutes: '30分钟',
        oneHour: '1小时',
        oneDay: '1天',
        selectIP: '请选择高防IP',
        selectDomain: '请选择域名',
        time: '时间',
        location: '地区',
        defenseIP: '防御IP',
        domain: '域名',
        totalRequestIP: '请求IP总量',
        totalRequests: '请求总次数',
        totalNormalRequestIP: '正常访问IP总量',
        totalBlock: '阻止IP总数'
      }

    },
    urlLog: {
      labels: {
        oneMinute: '1分钟',
        fiveMinutes: '5分钟',
        thirtyMinutes: '30分钟',
        oneHour: '1小时',
        oneDay: '1天',
        time: '时间',
        domain: '域名',
        url: 'URL',
        totalRequestIP: '请求IP总量',
        totalRequests: '请求总次数',
        actions: '操作',
      },
      buttons: {
        limitURL: '限制URL',
      }

    },
    visitsLog: {
      labels: {
        oneMinute: '1分钟',
        fiveMinutes: '5分钟',
        thirtyMinutes: '30分钟',
        oneHour: '1小时',
        oneDay: '1天',
        selectIP: '请选择高防IP',
        selectDomain: '请选择域名',
        totalRequestIP: '请求IP总量',
        totalRequests: '请求总次数',
        totalNormalRequestIP: '正常访问IP总量',
        totalBlock: '阻止IP总数',
        defenseIP: '防御IP',
        domain: '域名',
        time: '时间',
      }

    },
    website: {
      resolved: '已解析',
      unresolved: '未解析',
      blacklist: '黑名单',
      whitelist: '白名单',
      warning: '警告',
      suspendConfirm: '您确定要暂停此条安全防护吗？',
      startupConfirm: '您确定要开启此条安全防护吗？',
      deleteProtectionConfirm: '您确定要删除此条安全防护吗？',
      deleteCertificateConfirm: '您确定要删除证书吗？',
      labels: {
        ddosIPOrDomain: '输入高防IP或域名搜索',
        domainName: '域名',
        resolutionStatus: '解析状态',
        serverIP: '服务器地址',
        ddosIP: '高防IP',
        protocolType: '协议类型',
        blackWhitelist: '黑白名单',
        certificate: '证书状态',
        noCertificate: '无证书',
        toBeVerified: '待验证',
        tlsSecurityPolicy: 'TLS安全策略',
        pendingExpiration: '将过期',
        expired: '已过期',
        suspendProtection: '暂停安全防护',
        startupProtection: '开启安全防护',
        deleteProtection: '删除安全防护',
        deleteCertificate: '删除证书',
        running: '运行中',
        configuring: '配置中',
        paused: '已暂停',
        creationTime: '添加时间',
        actions: '操作',
        status: '状态',
        advanced: '高级防护功能',
      },
      buttons: {
        uploadCertificate: '上传证书',
        set: '设置',
        suspend: '暂停',
        startup: '启动',
        edit: '编辑',
        delete: '删除',
        cancel: '取消',
        modifyCertificate: '修改证书',
        deleteCertificate: '删除证书',
        addWebsite: '添加网站',
        viewLog: '查看日志',
      }

    },
    nonWebsite: {
      warning: '警告',
      suspendConfirm: '确定要暂停此条转发规则吗？',
      startupConfirm: '确定要开启此条转发规则吗？',
      batchDeleteConfirm: '确定要删除选中的${len}条非网站防护规则？',
      deleteConfirm: '确定要删除此条非网站防护规则？',
      labels: {
        originIPOrDomain: '源站IP或域名',
        selectDdosIP: '请选择高防IP',
        forwardingProtocol: '转发协议',
        forwardingPort: '转发端口',
        originServerPort: '源站端口',
        forwardingMode: '回源转发模式',
        originServerIP: '源站IP',
        antiDdosPolicy: 'DDoS防护策略',
        proxyProtocol: 'Proxy Protocol',
        ddosIP: '高防IP',
        suspendTitle: '暂停规则',
        startupTitle: '启动规则',
        deleteTitle: '删除规则',
        running: '运行中',
        booting: '启动中',
        configuring: '配置中',
        paused: '已暂停',
        creationTime: '添加时间',
        actions: '操作',
        status: '状态',
        AddRule: '添加规则',
      },
      buttons: {
        set: '设置',
        pause: '暂停',
        startup: '启动',
        edit: '编辑',
        delete: '删除',
        batchDelete: '批量删除:',
        cancel: '取消',
      }

    },
    components: {
      selectPayment: '请选择支付方式',
      enterLoginPassword: '请输入登录密码',
      createOrderFail: '创建订单失败',
      buttons: {
        cancel: '取消',
        confirm: '确认',
        ok: '关闭',
        done: '完成',
        submit: '提交',
        submitting: '提交中',
        delete: '删除',
      },

      antDialog: {
        configuration: {

          invalidDomainNumber: '域名数量最小为${minDomainNum}',
          invalidQPSNumber: 'QPS数量最小为${minQpsNum}',
          invalidPortsNumber: '端口数量最小为${minPortNum}',
          invalidBandwidthNumber: '带宽必须在${minBandwidth} ~ ${maxBandwidth}之间',
          invalidDomainsMultiple: '域名数量必须为${domainInterval}的倍数',
          invalidQPSMultiple: 'QPS数量必须为${qpsInterval}的倍数',
          invalidPortsMultiple: '端口数量必须为${portInterval}的倍数',
          labels: {
            changeConfiguration: '升级配置',
            defense: '防御：',
            targetBandwidth: '目标带宽数值：',
            protectedDomains: '防护域名数：',
            qps: 'QPS:',
            protectedPorts: '防护端口数',
            regionalBlocking: '区域封禁：',
            staticCaching: '静态页面缓存：',
            preciseAccess: '精准访问控制：',
            charges: '需要支付：',
          },


        },
        renew: {
          selectedInstance: '您已选<span>${num}</span>个高防IP',
          labels: {
            renew: '续费高防IP',
            duration: '续费时长： ',
            charges: '需要支付：',
            oneMonth: '1个月',
            twoMonths: '2个月',
            threeMonths: '3个月',
            sixMonths: '半年',
            oneYear: '1年',
            twoYears: '2年',
            renewable: '可续费',
            expiredAt: '有效期至：${endTime}',
          }
        },
        set: {
          labels: {
            notificationSetting: '设置预警提示(IP层面)',
            ddosAttack: 'DDoS攻击',
            remindEvery6min: '默认间隔0.1小时(6分钟)提醒一次',
            remindEvery: '间隔',
            hours: '小时',
            excessiveBandwidth: '带宽超量',
            remindEvery5hours: '默认间隔5小时提醒一次',
            ipBlocking: 'IP被封禁',
          }

        },
        unblockIP: {
          labels: {
            unblockClientIP: '解封被禁客户端IP',
            ddosIP: '高防IP:',
            blockedIP: '被封禁IP:',
            suppertedIPTips: '支持多个IP，用英文逗号间隔',
          }
        }

      },
      logDialog: {
        statisticalPeriod: '统计周期： December 30, 2021 11:10 ~ December 30, 2021\n' +
          '            11:12',
        labels: {
          sourceAreaDistribution: '地区分析: 来源地区分布',
          region: '区域',
          domain: '域名',
          time: '时间',
          url: 'URL',
          clientIP: '客户端IP',
          defenseIP: '防御IP',
          totalRequests: '请求总次数',
          normalRequests: '正常请求次数',
          attackRequests: '攻击请求次数',
          totalRequestingIP: '请求IP总量',
          totalBlockedIP: '阻止IP总数',
        },
        analyzeArea: {
          sourceAreaDistribution: '地区分析: 来源地区分布',


        },
        analyzeIP: {
          sourceIPDistribution: '地区分析: 来源IP分布',

        },
        analyzeURL: {
          URIDistribution: '地区分析: URI分布',

        },
        analyzeVisits: {
          visits: '地区分析: 访问次数',

        },
        Attack: {

        },
        blockArea: {
          activateTips: '区域封禁功能需要开通高防IP的"区域封禁"功能，如需修改区域封禁规则，请到"网站防护"对应域名旁"设置"中修改',
          supportTips: '区域封禁功能暂只支持封禁国家',

          labels: {
            blockArea: '封禁地区',
            blockIP: '封禁IP：',
            blockDomain: '封禁域名：',
            blockAreaColon: '封禁地区：',
          }

        },
        blockIP: {
          labels: {
            blockClientIP: '被封客户端IP',
            clientIP: '客户端IP：',
            oneIPOneLine: '一行一个IP',
            blockTime: '被封时间',
            fiveMinutes: '5分钟',
            tenMinutes: '10分钟',
            fifteenMinutes: '15分钟',
            thirtyMinutes: '30分钟'
          }

        },
        limitURL: {
          ruleCharacters: '规则名称为英文字母、数字和下划线（_）组成，不超过128个字符。',
          uriTips: '温馨提示：不支持填写网站域名。<br />如要防护整个网站的URI请求，请填写一个字符/，同时匹配规则选择 "前缀匹配"。<br /> 如要防护网站首页，请填写一个字符/，同时匹配规则选择 "完全匹配"。',
          exactMatchingTips: '"完全匹配" 即为精确匹配。例如：URI为 / ，则只能匹配首页。<br />URI为 /a ，则只能匹配 /a，不能匹配 /a/b等。',
          prefixMatchingTips: '"前缀匹配" 可匹配以某个URI为前缀的所有URI。例如：URI为 / ，可匹配整个网站的URI请求。<br />URI为 /a，可匹配 /a， /a/b等。',
          frequencyTips: '如果某个客户端的请求频率触发了某条规则（例如：URI为 /a，匹配规则为 “完全匹配”）， 则对该客户端的下一次请求作出相应阻断。',


          labels: {
            editRule: '编辑频率控制规则',
            ruleName: '规则名称：',
            url: 'URI：',
            mustStart: '必须以 / 开始',
            matchingRule: '匹配规则：',
            exactMatching: '完全匹配',
            prefixMatching: '前缀匹配',
            interval: '检验时长:',
            second: '秒',
            milliSecond: '毫秒',
            times: '次',
            singleIPVisits: '单一IP访问次数:',
            blockingType: '阻断类型：',
            refusal: '拒绝：丢弃请求，请求不会回源。',
            humanIdentification: '人机识别： 对请求作人机验证，如通过验证，则转发请求至源站，否则丢弃请求。',
            uriBlocking: '封禁URI： 配合封禁时间，在封禁时间内，对指定URI的所有请求，均将被丢弃。',
            ipBlocking: '封禁IP： 配合封禁时间，在封禁时间内，丢弃该客户端的所有请求。',
          }

        },
        rawLog: {
          labels: {
            rawLog: '原始日志'
          }

        }

      },
      websiteDialog: {
        addWebsite: {
          ipSegmentWhitelistTips: '重要提醒：添加网站前，请确保已经将回源IP段  ( <span class="blue">${ipSegment}</span>)  添加到您的云服务器白名单/安全组中，如有安装云锁、安全狗等防护软件，也需将上述回源IP段添加到上述软件的白名单里，否则高防IP会被封禁拦截无法回源，造成用户无法访问。',
          domainResolutionTips: '高防将自动匹配该泛域名对应的子域名。 例如，配置一条*.text.com，即可同时匹配a.text.com、b.text.com、www.text.com等域名。 泛域名仅占用一条配置名额。 如果同时存在泛域名和精确域名配置（如*.text.com和www.text.com）， 将优先使用精确域名所配置的转发规则和防护策略。',
          loadBalanceTips: '支持配置最多10个源站IP地址。<br />' +
            '配置多个源站IP后，DDoS高防实例以IP Hash的方式转发网站访问流量至源站，自动实现源站的负载均衡。<br />' +
            '如果您的源是IIS服务器且需要使用HTTPS,请确保开启 "需要服务器名称指示"。',
          httpCheckTips: '默认情况下：HTTP协议的请求以HTTP协议回源，HTTPS协议的请求以HTTPS协议回源。 如果勾选HTTP后，HTTPS协议的请求将以HTTP协议回源。<br />' +
            '注意：如果源站配置了HTTP重定向到HTTPS，请不要勾选此项，否则用户的请求将会陷入无休止的重定向。',
          httpsUpstreamTips: '如果勾选HTTPS后，将强制浏览器以HTTPS协议访问，源站无需再配置HTTP重定向到HTTPS。<br />' +
            '注意：如果源站配置了HTTPS重定向到HTTP，请不要勾选此项，否则用户的请求将会陷入无休止的重定向。',
          noInstanceTips: '无可用实例，已全部暂停，请检查是否过期，及时续费。',
          selectInstance: '请选择实例',
          protocolTips: '如果要防护的网站支持HTTPS加密认证，则必须勾选HTTPS。<br />' +
            '同时，您可以根据网站实际支持的协议类型勾选其他协议类型。',
          labels: {
            addWebsite: '添加网站',
            package: '功能套餐:',
            standard: '标准功能',
            instance: '选择实例:',
            domain: '网站域名:',
            protocolType: '协议类型：',
            serverAddress: '服务器地址:',
            upstreamIP: '源站IP',
            upstreamDomain: '请填写源站域名,支持一个',
            serverPort: '服务器端口:',
            originIPOrDomainTips: '源站IP，多个用英文逗号隔开，不可重复最多10个。源站域名,支持一个。',
            forcedBackToUpstream: '强制回源',
            mandatoryAccess: '强制访问',
            appToken: 'App Token:',
          }

        },
        blockRegions: {
          labels: {
            blockRegions: '设置区域封禁',
            checkAll: '全选',
            reverse: '反选',
            checkAllCountries: '选择所有国家',
          }

        },
        editAccelerationRules: {
          ruleCharacters: '规则名称为英文字母、数字和下划线（_）组成，不超过128个字符。',

          labels: {
            ruleName: "规则名称:",
            url: "URI：",
            mustStartWith: "必须以 / 开始。",
            cacheMode: "缓存模式：",
            standard: "标准",
            standardTips: "自动缓存js、css等静态资源文件。",
            enhanced: "增强",
            enhancedTips: "尝试缓存请求的URI资源。",
            noCache: "不缓存",
            noCacheTips: "不会缓存请求的URI资源。",
            matchingRule: "匹配模式：",
            exactMatching: "完全匹配",
            exactMatchingTips: "填写的URI与请求的URI完全一致才调用缓存",
            prefixMatching: "前缀匹配",
            prefixMatchingTips: "填写的URI与请求的URI从开始部分匹配就调用缓存",
            requestType: "请求方法:",
            expirationTime: "过期时间：",
          }

        },
        editCertificate: {
          certExample: '示例格式：\r\n-----BEGIN CERTIFICATE-----\r\n******************************\r\n-----END CERTIFICATE-----',
          privateKeyExample: '示例格式：\r\n-----BEGIN PRIVATE KEY-----\r\n******************************\r\n-----END PRIVATE KEY-----\r\n或者：\r\n-----BEGIN RSA PRIVATE KEY-----\r\n**********************************\r\n-----END RSA PRIVATE KEY-----',
          labels: {
            editCertificate: '设置证书和私钥',
            serverIP: '服务器地址:',
            manualUpload: '手动上传',
            domainName: '域名：',
            certificateName: '证书名称：',
            certCharacters: '名称仅支持英文字母、数字、下划线、中线',
            certFile: '证书文件：',
            certTips: '对于.pem、.cer、.crt格式的证书，您可以使用文本编辑器直接打开证书文件，<br />复制其中的文本内容。对于其他格式（如.pfx、.p7b等）的证书，您需要将证<br />书文件转换成.pem格式后，才能用文本编辑器打开并复制其中的文本内容。',
            secretKey: '私钥文件：',
            enterCertName: '请输入证书名称',
          }

        },
        editFrequencyRules: {
          labels: {
            editRule: '添加/编辑频率控制规则',
            ruleName: '规则名称：',
            ruleCharacters: '规则名称为英文字母、数字和下划线（_）组成，不超过128个字符。',
            uri: 'URI：',
            mustStartWith: '必须以 / 开始',
            matchingTips: '温馨提示：不支持填写网站域名。<br />如要防护整个网站的URI请求，请填写一个字符/，同时匹配规则选择 "前缀匹配"。<br /> 如要防护网站首页，请填写一个字符/，同时匹配规则选择 "完全匹配"。',
            matchingRule: '匹配规则：',
            exactMatching: '完全匹配',
            exactMatchingTips: '即为精确匹配。例如：URI为 / ，则只能匹配首页。<br />URI为 /a ，则只能匹配 /a，不能匹配 /a/b等。',
            prefixMatching: '前缀匹配',
            prefixMatchingTips: '可匹配以某个URI为前缀的所有URI。例如：URI为 / ，可匹配整个网站的URI请求。<br />URI为 /a，可匹配 /a， /a/b等。',
            interval: '检验时长：',
            second: '秒',
            millisecond: '毫秒',
            singleIPVisits: '单一访问次数：',
            times: '次',
            blockingType: '阻断类型：',
            refusal: '拒绝：丢弃请求，请求不会回源。',
            humanIdentification: '人机识别： 对请求作人机验证，如通过验证，则转发请求至源站，否则丢弃请求。',
            uriBlocking: '封禁URI：配合封禁时间，在封禁时间内，对指定URI的所有请求，均将被丢弃。',
            ipBlocking: '封禁IP： 配合封禁时间，在封禁时间内，丢弃该客户端的所有请求。',
            blockedTips: '如果某个客户端的请求频率触发了某条规则（例如：URI为 /a，匹配规则为 “完全匹配”）， 则对该客户端的下一次请求作出相应阻断。',
            integerFrom1to1440: '输入1 - 1440的整数',
            minute: '分钟',
            banDuration: '封禁时长：输入1 - 1440的整数',
          }

        },
        editPreciseRules: {
          labels: {
            editRule: '添加/编辑精准访问控制规则',
            ruleName: '规则名称：',
            ruleCharacters: '规则的名称为英文字母、数字和下划线（_）组成，不超过128个字符',
            conditionalRelation: '条件关系：',
            and: 'AND',
            or: 'OR',
            matchingCondition: '匹配条件：',
            matchingField: '匹配字段',
            logicalSymbol: '逻辑符',
            matchingContent: '匹配内容 (英文大小写敏感)',
            matchingTips: '暂时不支持通过正则表达式描述，但允许设置为空值。<br />' +
              '支持添加多个匹配条件。若添加多个匹配条件，则只有当访问请求满足所有条件时才算命中。',
            actions: '操作',
            AddALine: '添加一行',
            ruleAction: '匹配动作：',
            expiration: '规则有效期:',
          }

        },
        editWebsite: {
          ipSegmentWhitelistTips: '重要提醒：添加网站前，请确保已经将回源IP段  ( <span class="blue">${ipSegment}</span>)  添加到您的云服务器白名单/安全组中，如有安装云锁、安全狗等防护软件，也需将上述回源IP段添加到上述软件的白名单里，否则高防IP会被封禁拦截无法回源，造成用户无法访问。',
          domainResolutionTips: '高防将自动匹配该泛域名对应的子域名。 例如，配置一条*.text.com，即可同时匹配a.text.com、b.text.com、www.text.com等域名。 泛域名仅占用一条配置名额。 如果同时存在泛域名和精确域名配置（如*.text.com和www.text.com）， 将优先使用精确域名所配置的转发规则和防护策略。',
          httpCheckTips: '默认情况下：HTTP协议的请求以HTTP协议回源，HTTPS协议的请求以HTTPS协议回源。 如果勾选HTTP后，HTTPS协议的请求将以HTTP协议回源。<br />' +
            '注意：如果源站配置了HTTP重定向到HTTPS，请不要勾选此项，否则用户的请求将会陷入无休止的重定向。',
          loadBalanceTips: '支持配置最多10个源站IP地址。<br />' +
            '配置多个源站IP后，DDoS高防实例以IP Hash的方式转发网站访问流量至源站，自动实现源站的负载均衡。<br />' +
            '如果您的源是IIS服务器且需要使用HTTPS,请确保开启 "需要服务器名称指示"。',
          httpsUpstreamTips: '如果勾选HTTPS后，将强制浏览器以HTTPS协议访问，源站无需再配置HTTP重定向到HTTPS。<br />' +
            '注意：如果源站配置了HTTPS重定向到HTTP，请不要勾选此项，否则用户的请求将会陷入无休止的重定向。',
          protocolTips: '如果要防护的网站支持HTTPS加密认证，则必须勾选HTTPS。<br />' +
            '同时，您可以根据网站实际支持的协议类型勾选其他协议类型。',
          labels: {
            editWebsite: '编辑网站',
            package: '功能套餐:',
            standard: '标准功能',
            instance: '选择实例:',
            domain: '网站域名:',
            protocolType: '协议类型：',
            serverAddress: '服务器地址:',
            upstreamIP: '源站IP',
            upstreamDomain: '请填写源站域名,支持一个',
            originIPOrDomainTips: '源站IP，多个用英文逗号隔开，不可重复最多10个。源站域名,支持一个。',
            serverPort: '服务器端口:',
            forcedBackToUpstream: '强制回源',
            mandatoryAccess: '强制访问',
            appToken: 'App Token:',
            selectInstance: '请选择实例',
          }

        },
        purchaseRules: {
          labels: {
            purchaseQuantityRules: '新增规则数量',
            currentQuantityRulesAvailable: '当前可用规则总数: 10 条',
            newRulesQuantity: '升级数量: ',
            charges: '需要支付: ',
          }

        },
        setBlacklist: {
          supportFormat: '支持以IP或IP/掩码格式填写。<br />\n' +
            '黑名单或白名单下最多均支持添加200个，多个之间用空格或换行分隔。黑名单支持添加0.0.0.0/0，表示拦截来自除白名单中配置的正常IP外所有IP的访问请求。<br />\n' +
            '在部分情况下，可能需要经过一些访问流量和时间后，黑白名单（针对域名）设置才会真正生效。如果黑白名单（针对域名）开启后，设置未立即生效，请尝试继续访问域名数次。',
          labels: {
            setBlacklistWhitelist: '设置黑白名单（针对域名）',
            blacklist: '黑名单',
            whitelist: '白名单',
            enterContent: '请输入IP名单',
          }

        },
        setNotice: {
          labels: {
            setWarningNotice: '设置预警提示',
            remindEvery: '间隔',
            hours: '小时提醒一次',
          }

        },
        setToken: {
          exceptionTips: '最多支持例外链接添加100个，多个之间用英文逗号（,）分隔，且不需要域名，不支持带参数（会直接忽略参数）<br />\n' +
            '\n' +
            '          设置后，这些链接不会再校验APP Token,请谨慎操作。',
          labels: {
            setTokenExceptionUrl: '设置URL例外',
          }

        }

      },
      nonDialog: {
        addRule: {
          forwardingPortRange: '范围1-64999，不可使用80、443、8080、843、53、22、10050',
          originPortRange: '范围1-64999',
          originServerIPLimit: '支持最多20个，用英文逗号(,)隔开，不可重复',
          proxyProtocolTips: '如要获取请求用户的真实IP，请勾选此项。源站也需支持PROXY protocol。',
          labels: {
            AddRule: '添加规则',
            WheelMode: '回源转发模式',
            Instance: '选择实例',
            ForwardingProtocolWithColon: '转发协议',
            forwardingPort: '转发端口',
            originServerPort: '源站端口',
            LSVForwardingRules: 'LSV转发规则',
            OriginServerIP: '源站IP',
            MatchingRule: '获取用户真实IP',
            ProxyProtocol: 'Proxy Protocol',
            ForwardProtocol: '转发协议',
          },
        },
      },
    },
    titles: {
      antiDdosIP: '高防IP',
      web: '高防IP网站防护',
      noneWeb: '高防IP非网站防护 ',
      fullLog: '全量日志',
      ipVisits: '访问次数',
      ipRegionRanking: '请求地区排行',
      ipRanking: '请求IP排行',
      //以下暂无页面
      urlLog: '访问URL',
      featuresLog: 'HTTP特征',
      layerLog: '四层日志',
      layerChart: '四层图表',
      attackLog: '代理攻击分析',

      // ipSetting: 'Anti-DDoS IP Setting',
      // webSetting: 'IP Website Protection Setting',
    },
    util: {
      Failed: '失败',
      NotTriggered: '未触发',
      WatchAccess: '观察放行',
      Abnormal: '异常',
      Access: '放行',
      AITriggered: '触发人机校验',
      Blocked: '拦截',
      RulesBlocked: '规则拦截',
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh-CN/defense.js